<template>
    <van-pull-refresh v-model="isRefreshing" @refresh="__refresh">
        <van-list :immediate-check="false" :offset="500" v-model="isLoading" @load="__load" :finished="finished">
            <slot/>
        </van-list>
    </van-pull-refresh>
</template>

<script>
const COMPONENT_NAME = 'VanListView'
export default {
  name: COMPONENT_NAME,
  props: {
    loading: Boolean,
    refreshing: Boolean,
    finished: Boolean
  },
  data () {
    return {
      isLoading: false,
      isRefreshing: false
    }
  },
  watch: {
    loading: {
      immediate: true,
      handler () {
        this.isLoading = this.loading
      }
    },
    refreshing: {
      immediate: true,
      handler () {
        this.isRefreshing = this.refreshing
      }
    }
  },
  methods: {
    __load () {
      this.$emit('load')
    },
    __refresh () {
      this.$emit('refresh')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/list-view/list-view.vue